import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    backgroundColor: "#FFDE24",
  },

  [props.theme.breakpoints.down("lg")]: {
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));
export const GridStyled = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  height: "100%",
  maxWidth: "1440px",
  margin: "auto",
  gap: "8px",
  padding: "40px 24px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    alignSelf: "stretch",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 24px",
  },
}));

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1240px",
  padding: "32px 40px",
  justifyContent: "space-between",
  alignItems: "center",
  borderRadius: "16px",
  border: "2px solid #512ACC3D",
  background: "#FFF",

  [props.theme.breakpoints.down("lg")]: {
    padding: "16px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    alignSelf: "stretch",
  },
}));

export const TaglineContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "24px",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    padding: "12px 0px",
    alignItems: "flex-start",
    flex: "1 0 0",
    gap: "16px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "0px",
  },
}));

export const TaglineSubContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
  justifyContent: "center",
}));

export const TaglineOverline = styling(Typography)((props) => ({
  color: "#512ACC",
  fontFamily: "Manrope",
  fontSize: "20px",
  fontWeight: "600",
  lineHeight: "24px",
  letterSpacing: "0.3px",
  alignSelf: "stretch",
  textTransform: "uppercase",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "14px",
    lineHeight: "16.8px",
    letterSpacing: "0.21px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontWeight: "500",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "32px",
  fontWeight: "400",
  lineHeight: "38.4px",
  fontFamily: "Georgia",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "rgba(0, 0, 0, 0.60)",
  fontFamily: "Inter",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "16px",
    lineHeight: "19.2px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    lineHeight: "22.4px",
  },
}));

export const ImageStyled = styling("img")((props) => ({
  width: "168px",
  height: "168px",
  borderRadius: "8px",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const LeftContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "706px",
  alignItems: "center",
  gap: "32px",
  // flexShrink: "0",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "unset",
    gap: "40px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
    gap: "16px",
    alignItems: "flex-start",
  },
}));

export const RightContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  flexDirection: "column",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const ButtonLink = styling(Button)((props) => ({
  fontSize: "20px",
  fontFamily: "Inter",
  fontWeight: "600",
  backgroundColor: "none",
  color: "#512ACC",
  textTransform: "none",
  borderRadius: "100px",
  display: "flex",
  height: "42px",
  padding: "0px 24px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  ":hover": {
    backgroundColor: "none",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "16px",
    fontWeight: 700,
  },
}));
